var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverageAnalysisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1895 39L30.6347 30.4807C29.4165 31.4483 28.118 32.1969 26.7392 32.7264C25.3604 33.2563 23.8471 33.5212 22.1994 33.5212C19.7541 33.5212 17.5348 32.9349 15.5414 31.7623C13.5478 30.5899 11.9662 29.0374 10.7967 27.1048H13.965C14.9719 28.2806 16.179 29.2162 17.5865 29.9118C18.9943 30.607 20.5319 30.9547 22.1994 30.9547C25.1729 30.9547 27.7061 29.9126 29.7988 27.8286C31.8916 25.7448 32.9379 23.2222 32.9379 20.2606C32.9379 17.2991 31.8916 14.7764 29.7988 12.6927C27.7061 10.6086 25.1729 9.56657 22.1994 9.56657C19.3864 9.56657 16.9578 10.5159 14.9135 12.4146C12.8694 14.313 11.7328 16.6432 11.5038 19.4051H8.9265C9.15559 15.904 10.5361 12.9613 13.0681 10.5769C15.6002 8.19231 18.6439 7 22.1994 7C25.9155 7 29.0637 8.285 31.6441 10.855C34.2248 13.4247 35.5152 16.5599 35.5152 20.2606C35.5152 21.9015 35.2491 23.4112 34.7171 24.7898C34.185 26.1686 33.4333 27.4645 32.462 28.6777L41 37.1803L39.1895 39ZM20.534 26.8417L17.6625 17.3681L15.2309 24.2752H7V22.2347H13.7902L16.6252 14.1073H18.8223L21.6242 23.459L23.7028 17.1016H25.8999L28.4771 22.2347H29.8319V24.2752H27.2181L24.9845 19.826L22.6882 26.8417H20.534Z",
    fill: "#0085DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageAnalysisIcon);
export default __webpack_public_path__ + "static/media/coverageAnalysisIcon.5bcb761d9460796740739b33e22dc890.svg";
export { ForwardRef as ReactComponent };